import classNames from 'classnames';

// TODO: why do we need this? (V.T. 20.12.2021)
export default function ClassNames(...args) {
	return classNames.call(this, ...args) || null;
}
